import { render, staticRenderFns } from "./Lgx279928282164494336.vue?vue&type=template&id=be20b708&scoped=true&"
import script from "./Lgx279928282164494336.vue?vue&type=script&lang=js&"
export * from "./Lgx279928282164494336.vue?vue&type=script&lang=js&"
import style0 from "./Lgx279928282164494336.vue?vue&type=style&index=0&id=be20b708&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be20b708",
  null
  
)

export default component.exports